var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.25,
    cy: 13,
    r: 12,
    stroke: "#0FC06B",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1723 7.00449L13.25 7C13.5919 7 13.8737 7.25736 13.9122 7.58892L13.9167 7.66667V12.3333H18.5833C18.9252 12.3333 19.207 12.5907 19.2455 12.9223L19.25 13C19.25 13.3419 18.9926 13.6237 18.6611 13.6622L18.5833 13.6667H13.9167V18.3333C13.9167 18.6752 13.6593 18.957 13.3277 18.9955L13.25 19C12.9081 19 12.6263 18.7426 12.5878 18.4111L12.5833 18.3333V13.6667H7.91667C7.57478 13.6667 7.293 13.4093 7.25449 13.0777L7.25 13C7.25 12.6581 7.50736 12.3763 7.83892 12.3378L7.91667 12.3333H12.5833V7.66667C12.5833 7.32478 12.8407 7.043 13.1723 7.00449L13.25 7L13.1723 7.00449Z",
    fill: "#0FC06B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/add-plus.d355a339760e67f004f8ed82e8131ebb.svg";
export { ForwardRef as ReactComponent };